export default __webpack_public_path__ + "static/majority-2d3c1d38f13a855fc9f004ad1ce0149d.gif";